import { transaksi } from '../action-types';

const initialState = {
  data: null,
  isFetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case transaksi.FETCH_TRANSAKSI:
      return {
        ...state,
        isFetching: true,
      };
    case transaksi.GET_TRANSAKSI:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    case transaksi.NULL_TRANSAKSI:
      return {
        ...state,
        isFetching: false,
        data: null,
      };
    default:
      return state;
  }
};
